import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { confirmAlert } from 'react-confirm-alert'; 
import HmEventRegistry from './../../model/HmEventRegistry';
import RbUtil from './../../util/RbUtil';

var ErrorPrompt = function(obj){
  var rb = function(rawTxt,replaceStringArray=[]){
    return RbUtil.getText(rawTxt,replaceStringArray);
  }

  var title = rb("500.title");
  var msg = "";
  var btnHandlers = obj.buttons || null;

  try{
   title = rb(obj.title);
 }catch(e){}

 try{
  if(obj.reference_id){
    msg += rb("500.reference_id").replace("{#reference_id}", obj.reference_id);
  }

  if(obj.msg){
    msg += rb(obj.msg);
  }else if(obj.message){
   msg += rb(obj.message);
 }

}catch(e){

}

var errObj = {
  "error_id" : obj.reference_id,
  "status_code": obj.status_code || 500,
  "url":obj.url || "",
  "enum_key":"source",
    "enum_replace_key":"encounteredErrorSource",
    "enum_replace_value":obj.server_src || "um"
};


HmEventRegistry.fireEvent("TRACK_EVENT","error_encountered",errObj);


this.show = function(){
  var me = this;

  var buttons = [];

  try{
    if(btnHandlers !== undefined && btnHandlers !== null && btnHandlers.length > 0){
      for(var i=0;i<btnHandlers.length; i++){
        buttons.push({
          label: btnHandlers[i].label || me.rb("btn.ok"),
          onClick: (typeof btnHandlers[i].handler === "function") ? btnHandlers[i].handler : () => {}
        })
      }
    }
  }catch(e){}

  if(buttons.length == 0){
    buttons.push({
      label: 'Ok',
      onClick: () => {}
    });
  }

  return confirmAlert({
    title: title || 'Alert',
    message:  msg ? ReactHtmlParser( msg) : 'Hello..',
    buttons: buttons
  }); 
}


}


HmEventRegistry.registerEvent("ERROR_PROMPT",function(obj){
  new ErrorPrompt(obj).show();
});


// WEBPACK FOOTER //
// ./src/views/core/ErrorPrompt.js